import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
import LandingPage from './components/LandingPage';
import DashboardInterface from './components/DashboardInterface';
import SearchInterface from './components/SearchInterface';
import DocumentViewer from './components/document-viewer/DocumentViewer';
import DocumentUpload from './components/DocumentUpload';
import KnowledgeGraph from './components/graph/KnowledgeGraph';
import DocumentsInterface from './components/DocumentsInterface';
import SmartDocument from './components/smart-docs/SmartDocs.tsx';
import Organizations from './components/Organizations';
import Chatbot from './components/Chatbot.tsx';
import { Sidebar } from './components/Sidebar';
import { TopNav } from './components/TopNav';
import ConfigurationInterface from "./components/Configurations";
import { useState } from 'react';
import { UploadProvider } from './context/UploadContext';
import { ThemeProvider } from './context/ThemeContext';
import { Toaster } from "@/components/ui/toaster"
import OrgDetail from "@/components/OrgDetail.tsx";
import ChatbotWithNavigation from './components/ChatbotWithNavigation';
// import Products from './components/Products';
import ProductsPageV2 from './components/ProductsPageV2.tsx';
import CareersPage from './components/CareersPage';
import AboutUsPage from './components/AboutUsPage';
import ContactUsPage from './components/ContactUsPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import PublicLayout from './components/PublicLayout';
import BlogPage from './components/blog/BlogPage';
import BlogPostPage from './components/blog/BlogPostPage';

const App = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  // const [user, setUser] = useState<{ name: string; role: string } | null>(null);
  // const [isLoading, setIsLoading] = useState(true);

  const toggleSidebar = () => {
    setIsCollapsed((prev) => !prev);
  }

  // useEffect(() => {
  //   fetch('/api/v1/auth/me')
  //     .then((res) => res.json())
  //     .then((data) => {
  //       if(data.user){
  //         setUser(data.user);
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch(() => {
  //       setUser(null);
  //       setIsLoading(false);
  //     });
  // }, []);

  // Protected route wrapper component
  const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    // if (isLoading) {
    //   return <div className="min-h-screen flex items-center justify-center bg-gray-50">Loading...</div>;
    // }

    // if (!user) {
    //   return <Navigate to="/" replace />;
    // }

    return (
      <div className="min-h-screen bg-gray-50 flex">
        <Sidebar isCollapsed={isCollapsed} toggleCollapse={toggleSidebar} />
        <div className="flex-1 flex flex-col">
          <TopNav isCollapsed={isCollapsed} user={null} />
          <main className="flex-1 overflow-auto">
            {children}
          </main>
          <ChatbotWithNavigation />
        </div>
      </div>
    );
  };

  return (
    <ThemeProvider>
    <UploadProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public routes */}
          {/* Public routes */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<LandingPage user={null} />} />
            <Route path="/solutions" element={<Navigate to="/products" replace />} />
            <Route path="/products" element={<ProductsPageV2 />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/contact-us" element={<ContactUsPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
          </Route>
          <Route path="/share/:documentId" element={<SmartDocument />} />

          <Route path="/" element={
            <ProtectedRoute>
              <DashboardInterface />
            </ProtectedRoute>
          } />

          {/* Protected routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardInterface />
            </ProtectedRoute>
          } />
          <Route path="/search" element={
            <ProtectedRoute>
              <SearchInterface />
            </ProtectedRoute>
          } />
          <Route path="/upload" element={
            <ProtectedRoute>
              <DocumentUpload />
            </ProtectedRoute>
          } />
          <Route path="/documents" element={
            <ProtectedRoute>
              <DocumentsInterface />
            </ProtectedRoute>
          } />
          <Route path="/documents/:documentId" element={
            <ProtectedRoute>
              <DocumentViewer />
            </ProtectedRoute>
          } />
          <Route path="/organizations" element={
            <ProtectedRoute>
              <Organizations />
            </ProtectedRoute>
          } />
          <Route path="/organizations/:organizationId" element={
            <ProtectedRoute>
              <OrgDetail />
            </ProtectedRoute>
          } />
          <Route path="/graph" element={
            <ProtectedRoute>
              <KnowledgeGraph />
            </ProtectedRoute>
          } />
          <Route path="/config" element={
            <ProtectedRoute>
              <ConfigurationInterface />
            </ProtectedRoute>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </UploadProvider>
    </ThemeProvider>
  );
};

export default App;